import React, { useState, useEffect } from "react";

export default function ImageGrid({ images }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageData, setImageData] = useState([]);
  const [showTags, setShowTags] = useState(false);

  useEffect(() => {
    const data = images.map((img) => ({
      ...img,
      likes: Math.floor(Math.random() * (200 - 160 + 1)) + 160,
      comments: Math.floor(Math.random() * (15 - 6 + 1)) + 6,
    }));
    setImageData(data);
  }, [images]);

  const openModal = (img) => {
    setSelectedImage(img);
    setShowTags(false); // resetujemo prikaz tagova svaki put
  };

  const closeModal = () => {
    setSelectedImage(null);
    setShowTags(false);
  };

  const handleTagClick = (tag) => {
    if (tag.url) {
      // možeš ovde da koristiš i react-router navigate umesto ovoga
      window.location.href = tag.url;
    }
  };

  return (
    <>
      <div className="image-grid">
        {imageData.map((img, index) => (
          <div
            key={index}
            className="image-item"
            onClick={() => openModal(img)}
          >
            <img src={img.src} alt={`img-${index}`} />
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>
              ✕
            </button>

            {/* Klikom na sliku prikazujemo / sakrivamo tagovane osobe */}
            <img
              src={selectedImage.src}
              alt="selected"
              className="modal-img"
              onClick={() => setShowTags((prev) => !prev)}
            />

            {/* Opis slike */}
            <p className="modal-description">{selectedImage.description}</p>

            {/* Lista tagovanih osoba (ako ima) */}
            {showTags && selectedImage.tags && selectedImage.tags.length > 0 && (
              <div className="modal-tags">
                {selectedImage.tags.map((tag, index) => (
                  <button
                    key={index}
                    className="tag-pill"
                    onClick={() => handleTagClick(tag)}
                  >
                    {tag.name}
                  </button>
                ))}
              </div>
            )}

            {/* Lajkovi i komentari */}
            <div className="modal-text">
              <span>{selectedImage.likes} likes</span>
              <span>{selectedImage.comments} comments</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
